export default "__VITE_ASSET__Bj9vg13g__"